import { Route, Routes } from "react-router-dom";
import { StoresPage } from "./list";
import ConciliationPage from "./conciliation";

export default function StoresRoutes() {
  return (
    <Routes>
      <Route path="/" element={<StoresPage />} />
      <Route
        path="/conciliacao-de-caixa-de-loja/:id_transaction"
        element={<ConciliationPage />}
      />
    </Routes>
  );
}
